import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

const useSchedule = () => {
  const { ezorder, authToken } = useContext(AuthContext);

  const scheduleEvents = async (calendarEvents) => {
    const response = await ezorder.post(
      `/shop/schedule`,
      { calendarEvents },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    return response;
  };

  const scheduleEvent = async (calendarEvent) => {
    const response = await ezorder.post(
      `/shop/schedule`,
      { calendarEvent },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    return response;
  };

  const updateEvent = async (calendarEvent) => {
    const response = await ezorder.put(
      `/shop/schedule/events/${calendarEvent.id}`,
      { calendarEvent },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    return response;
  };

  const deleteEvent = async (eventId) => {
    const response = await ezorder.delete(`/shop/schedule/events/${eventId}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    return response;
  };

  return {
    scheduleEvents,
    updateEvent,
    deleteEvent,
  };
};
export default useSchedule;
